import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/HomePageClient.tsx")